import createOrUpdateHiddenField from './createOrUpdateHiddenField';

const injectUniteCorrelationId = (form) => {
	const correlationId = sessionStorage.getItem('SaveUniteCorrelationId');

	if (correlationId) {
		createOrUpdateHiddenField(
			form,
			'_custom=UD_CORRELATION_ID=-1=udCorrelationId',
			correlationId
		);
	}
};

export default injectUniteCorrelationId;
